import { Link, Route, Routes } from 'react-router-dom';

import { AuthGate } from './components/AuthGate';
import { ReportsPage } from './pages/ReportsPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { StudiesReportPage } from './pages/StudiesReportPage';
import { UploadsReportPage } from './pages/UploadsReportPage';
import { Layout } from './components/Layout';
import { PageHeader } from './components/PageHeader';
import { AdminsPage } from './pages/AdminsPage';
import { CenterDetailPage } from './pages/CenterDetailPage';
import { CenterEditPage } from './pages/CenterEditPage';
import { CenterNewPage } from './pages/CenterNewPage';
import { CentersPage } from './pages/CentersPage';
import { ClinicsPage } from './pages/ClinicsPage';
import { DnsPage } from './pages/DnsPage';
import { EdgeNodeDetailPage } from './pages/EdgeNodeDetailPage';
import { EdgeNodesPage } from './pages/EdgeNodesPage';
import { FleetOverviewPage } from './pages/FleetOverviewPage';
import { IssuesPage } from './pages/IssuesPage';
import { LogsPage } from './pages/LogsPage';
import { PlanPage } from './pages/PlanPage';
import { TerminalSessionsPage } from './pages/TerminalSessionsPage';

function NotFoundPage() {
  return (
    <>
      <PageHeader
        title="Page not found"
        subtitle="That address does not match any page in the fleet controller."
      />
      <p>
        <Link to="/">Back to the fleet overview</Link>
      </p>
    </>
  );
}

export function App() {
  // Rendered before the gate: nobody redeeming an invite is signed in, so
  // wrapping it in AuthGate would show them a login form for the account they
  // are trying to create a password for.
  if (window.location.pathname === '/set-password') {
    return <SetPasswordPage />;
  }

  return (
    <AuthGate>
      {(me) => (
        <Routes>
          <Route element={<Layout me={me} />}>
            <Route index element={<FleetOverviewPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="reports/uploads" element={<UploadsReportPage />} />
            <Route path="reports/studies" element={<StudiesReportPage />} />
            <Route path="centers" element={<CentersPage />} />
            <Route path="centers/new" element={<CenterNewPage />} />
            <Route path="centers/:slug" element={<CenterDetailPage />} />
            <Route path="centers/:slug/edit" element={<CenterEditPage />} />
            <Route path="clinics" element={<ClinicsPage />} />
            <Route path="issues" element={<IssuesPage />} />
            <Route path="plan" element={<PlanPage />} />
            <Route path="dns" element={<DnsPage />} />
            <Route path="edge-nodes" element={<EdgeNodesPage />} />
            <Route path="edge-nodes/:uuid" element={<EdgeNodeDetailPage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="terminal-sessions" element={<TerminalSessionsPage />} />
            <Route path="terminal-sessions/:id" element={<TerminalSessionsPage />} />
            <Route path="admins" element={<AdminsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      )}
    </AuthGate>
  );
}
